import type { Product } from '@src/core/buyerApiClient';
import { schedulingContainsMinute } from '@src/common/schedulings';
import { tariffIsAvailable } from '@src/domains/tariffs';
import type { TariffsPerType } from '@src/stores/product';
import type { HourListItem } from '@src/domains/products/features/productAdder/types/productAdder';

export interface TariffsPerTypeExtended extends TariffsPerType {
  isAvailable: boolean;
}

export function getDisplayableTariffs(
  listOfTariffsPerType: TariffsPerType[],
  selectedTariffsPerType: TariffsPerType[],
  hoursList: readonly HourListItem[],
): TariffsPerType[] {
  if (hoursList.length === 0) return listOfTariffsPerType;

  return listOfTariffsPerType.filter(
    (tariff) => tariff.selectedQuantity || hasOverlappingSchedulingWithAllSelected(tariff, selectedTariffsPerType),
  );
}

function hasOverlappingSchedulingWithAllSelected(
  candidate: TariffsPerType,
  selectedTariffsPerType: TariffsPerType[],
): boolean {
  return selectedTariffsPerType.every((selected) =>
    selected.schedulings.some((scheduling) =>
      scheduling.availableScheduleTimes?.some((time) =>
        candidate.schedulings.some((candidateScheduling) =>
          schedulingContainsMinute(candidateScheduling, time.minutes),
        ),
      ),
    ),
  );
}

export function sortTariffsByAvailability(
  tariffs: TariffsPerType[],
  product: Pick<Product, 'sellingMode'>,
): TariffsPerTypeExtended[] {
  return tariffs
    .map((tariffPerType) => ({
      ...tariffPerType,
      isAvailable: tariffIsAvailable(product as Product, tariffPerType),
    }))
    .sort((a, b) => (a.isAvailable === b.isAvailable ? 0 : a.isAvailable ? -1 : 1));
}
